import apiCLient from '@shared/apiClient'

import { FetchEventsResponse } from '../types'

interface FetchEventsPayload {
  type: string
  limit?: number
  page: number
  personId: number
}

export const fetchEventsFn = async ({ type, limit, page, personId }: FetchEventsPayload): Promise<FetchEventsResponse> => {
  const response = await apiCLient.partneringOne('events').get(`events/load/person/${personId}`, {
    params: { type, limit, page, skipConsent: 1 },
  })
  return response.data.data
}
